import { MatxLoading } from "app/components";
import axiosKeyCloak from "axiosKeyCloak.js";
import axios from "axios.js";
import jwtDecode from "jwt-decode";
import useSnackbar from "app/hooks/useSnackbar";
import React, { createContext, useEffect, useReducer } from "react";
import { useContext } from "react";
import { TitleContext } from "./titleContext";
import Cookies from "js-cookie";
import useAuth from "app/hooks/useAuth";
import { sessionActions } from "app/redux/reducers/session";
import moment from "moment";
import { useNavigate } from "react-router-dom";

const initialState = {
  // initial state for user
  user: null,
  isInitialised: false,
  isAuthenticated: false,
};

const isValidToken = (accessToken) => {
  // check token is valid
  if (!accessToken) return false;

  const decodedToken = jwtDecode(accessToken);
  const currentTime = Date.now() / 1000;
  return decodedToken.exp > currentTime;
};

const setSession = (accessToken) => {
  // create session
  if (accessToken) {
    Cookies.set("accessToken", accessToken, { secure: true, httpOnly: true });
    localStorage.setItem("accessToken", accessToken);
    axiosKeyCloak.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;

    // Set global search option in header on refresh
    const filter_type = window.localStorage.getItem("filter_type");
    const filter_code = window.localStorage.getItem("filter_code");
    const filter_year = window.localStorage.getItem("filter_year");
    // if (filter_type && filter_code && filter_year) {
    if (filter_type && filter_code) {
      axios.defaults.headers.common.filter_type = filter_type;
      axios.defaults.headers.common.filter_code = filter_code;
      // axios.defaults.headers.common.filter_year = filter_year;
    }
  } else {
    Cookies.remove("accessToken");
    localStorage.removeItem("accessToken");
    delete axiosKeyCloak.defaults.headers.common.Authorization;
    delete axios.defaults.headers.common.Authorization;
    localStorage.removeItem("filter_type");
    localStorage.removeItem("filter_code");
    localStorage.removeItem("filter_year");
    localStorage.removeItem("block_filter_code");
    localStorage.removeItem("district_filter_code");
    window.localStorage.removeItem("filter_type");
    window.localStorage.removeItem("filter_code");
    window.localStorage.removeItem("filter_year");
  }
};

const reducer = (state, action) => {
  switch (action.type) {
    case "INIT": {
      const { isAuthenticated, user } = action.payload;
      return { ...state, user, isAuthenticated, isInitialised: true };
    }
    case "LOGIN": {
      const { user } = action.payload;
      return { ...state, user, isAuthenticated: true };
    }
    case "LOGOUT": {
      return { ...state, isAuthenticated: false, user: null };
    }
    case "REGISTER": {
      const { user } = action.payload;
      return { ...state, isAuthenticated: true, user };
    }
    default: {
      return state;
    }
  }
};

const AuthContext = createContext({
  ...initialState,
  method: "JWT",
  logout: () => { },
  login: () => Promise.resolve(),
  register: () => Promise.resolve(),
});

export const AuthProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const { setColorCode, ColorCode } = useContext(TitleContext);
  const [msg, sendNotification] = useSnackbar();
  const navigate = useNavigate();

  // API Login

  const generateLoginToken = async () => { // generate login token for traccar 
    let token = '';
    try {
      const expiration = moment().add(6, 'months').toISOString();
      const response = await fetch(`${process.env.REACT_APP_TRACCAR_API}/api/session/token`, {
        method: 'POST',
        credentials: 'include',
        body: new URLSearchParams(`expiration=${expiration}`),
      });
      if (response.ok) {
        token = await response.text();
      }
    } catch (error) {
      token = '';
    }
  };

  const handlePasswordLogin = async (userName) => { // traccar session create after login
    if (userName.length !== 18) {
      var email = userName
      var password = 'vts@123'
      if (email == 'mis' || email == 'state' || email == 'admin') {
        email = 'admin'
        password = '99Inchrod'
      }
      try {
        const response = await fetch(`${process.env.REACT_APP_TRACCAR_API}/api/session`, {
          method: 'POST',
          credentials: 'include',
          body: new URLSearchParams(`email=${email}&password=${password}`),
        });
        if (response.ok) {
          const user = await response.json();
          generateLoginToken();
          dispatch(sessionActions.updateUser(user));
          navigate('/');
        } else {
          throw Error(await response.text());
        }
      } catch (error) {
        console.log(error)
      }
    }
  };
  const login = async (username, password) => {
    try {
      let url =
        username.length > 17
          ? "/realms/students/protocol/openid-connect/token"
          : "/realms/users/protocol/openid-connect/token";
      const response = await axiosKeyCloak.post(url, {
        username,
        password,
        client_id: "react-app",
        grant_type: "password",
      });

      if (response.data.error) {
        sendNotification({
          msg: response.data.error_description,
          variant: "error",
        });
        // return Promise.reject(
        //   (response && response.data) || "Something went wrong!"
        // );
      }
      handlePasswordLogin(username)

      const { access_token } = response.data;
      // localStorage.setItem("existing_user_id", access_token);
      Cookies.set("existing_user_id", access_token, { secure: true, httpOnly: true });
      localStorage.setItem("existing_user_id", access_token);
      setSession(access_token);
      const user = jwtDecode(access_token);
      localStorage.setItem("user_id", user.sub)
      localStorage.setItem(
        "userRole",
        user.resource_access["react-app"].roles[0]
      );
      dispatch({ type: "LOGIN", payload: { user } });
      localStorage.setItem("ColorCode", user.theme_color);
      setColorCode(localStorage.getItem("ColorCode"));

      // if (user.default_pass_changed === undefined) {
      if (user.default_pass_changed === undefined || !user.default_pass_changed) {
        localStorage.setItem("password_status", true);
      } else {
        localStorage.setItem("password_status", false);
      }

    } catch (err) {
      sendNotification({ msg: "Please enter proper Login Credentials!!", variant: "error" });
      return [500, { message: "Internal server error" }];
    }
  };

  // API for register
  const register = async (email, username, password) => {
    const { data } = await axios.post("/api/auth/register", {
      email,
      username,
      password,
    });

    const { accessToken, user } = data;
    setSession(accessToken);
    dispatch({ type: "REGISTER", payload: { user } });
  };

  const logout = async () => {
    // logout function
    // await fetch(`${process.env.REACT_APP_AUTH_BASE_URL}/realms/mirsal/protocol/openid-connect/revoke`, {
    //   method: 'POST',
    //   headers: {
    //     'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    //   },
    //   body: {
    //     token: Cookies.get('accessToken'),
    //     token_type_hint: "access_token",
    //     client_id: "react_app",
    //     client_secret: 'Nit1N9TcEtmf0XMSkqzttCP9Va27Fhio'
    //   }
    // })
    // const response = await axiosKeyCloak.post(`/admin/realms/users/users/${localStorage.getItem("user_id")}/logout`);
    // if (response) {
    //   console.log(response)
    // }
    const responseLogout = await axios.get(`/logout`)

    if (responseLogout) {
      setSession(null);
      const userRole = localStorage.getItem("userRole");
      localStorage.removeItem("userRole");
      Cookies.remove("accessToken");
      Cookies.remove("existing_user_id");
      localStorage.removeItem("accessToken");
      localStorage.removeItem("existing_user_id");
      localStorage.removeItem("ColorCode");
      localStorage.removeItem("filter_type");
      localStorage.removeItem("filter_code");
      localStorage.removeItem("selected_school");
      localStorage.removeItem("holidayMonth");
      localStorage.removeItem("holidayYear");
      localStorage.removeItem("password_status");
      localStorage.removeItem('ColorCodeUpdate');
      window.localStorage.removeItem("Impersonate_status");
      localStorage.removeItem('transportSortingColumn');
      localStorage.removeItem('transportSortingRole');
      localStorage.removeItem('transportSortingMonth');
      delete axios.defaults.headers.common.filter_code;
      delete axios.defaults.headers.common.filter_type;
      localStorage.clear()
      dispatch({ type: "LOGOUT" });
      if (userRole != "student") {
        await fetch(`${process.env.REACT_APP_TRACCAR_API}/api/session`, {
          method: "DELETE",
          credentials: "include",
        });
      }
    } else {
      navigate(-1)
    }
  };

  useEffect(() => {
    // set user role in local storage
    (async () => {
      try {
        // const accessToken = Cookies.get("accessToken");
        const accessToken = localStorage.getItem("accessToken");
        if (accessToken && isValidToken(accessToken)) {
          setSession(accessToken);
          const user = jwtDecode(accessToken);
          localStorage.setItem("ColorCode", user.theme_color);
          setColorCode(user.theme_color);
          localStorage.setItem(
            "userRole",
            user.resource_access["react-app"].roles[0]
          );
          dispatch({
            type: "INIT",
            payload: { isAuthenticated: true, user },
          });
        } else {
          dispatch({
            type: "INIT",
            payload: { isAuthenticated: false, user: null },
          });
        }
      } catch (err) {
        dispatch({
          type: "INIT",
          payload: { isAuthenticated: false, user: null },
        });
      }
    })();
  }, []);

  if (!state.isInitialised) {
    // if state is not initialized then lodaing component shown
    return <MatxLoading />;
  }

  return (
    <AuthContext.Provider
      value={{ ...state, method: "JWT", login, logout, register }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
